// Geotab Camera Domain Configuration
export const geotabCameraConfig = {
  // Basic domain information
  id: 'geotab-camera',
  name: 'Geotab Camera',
  tagline: 'Professional Fleet Camera Solutions',
  description: 'Advanced camera systems for fleet safety and security.',
  
  // Assets
  logo: '/assets/logos/geotab-camera-logo.png',
  whiteLogo: '/assets/logos/geotab-camera-white-logo.png',
  favicon: '/assets/favicons/geotab-camera-favicon.png',
  icon: '/assets/icons/geotab-camera',
  
  // Navigation
  pages: ['home', 'solutions', 'blog'],
  navigation: [
    { name: 'Home', path: '/' },
    { name: 'Solutions', path: '/solutions' },
    { name: 'Blog', path: '/blog' },
  ],
  
  // CTAs
  cta: {
    primary: 'Request Demo',
    secondary: 'Buy Now'
  },
    
  // Shop link
  shopLink: 'https://shop.fleethoster.com/collections/geotab',

  // UI Configuration
  variant: 'corporate',
  showFeatures: true,
  showTestimonials: true,
  
  // Content sections
  hero: {
    title: 'Geotab Camera',
    subtitle: 'GO Focus Plus AI-powered camera solution with enhanced capabilities by Geotab',
    features: ['Easy Setup', 'High Quality', 'Affordable']
  },
  
  // Gallery/Image Slider configuration
  gallery: {
    title: 'Geotab Camera Solutions',
    subtitle: 'Explore our professional fleet cameras and safety solutions',
    description: 'See how Geotab Camera transforms fleet safety with advanced video technology'
  },

  features: {
    title: 'Geotab Camera Features',
    subtitle: 'Professional Fleet Camera',
    description: 'Geotab camera provide unmatched visibility, security, and peace of mind for your fleet operations.',
    items: [
      {
        title: 'Less Friction',
        description: 'Automatic device detection and pairing plus self-calibrating to eliminate the hassle',
        icon: '📹'
      },
      {
        title: 'Real intelligence',
        description: 'Our AI for DMS and ADAS help predict risks on road and in the cabin with the highest levels of confidence.',
        icon: '📡'
      },
      {
        title: 'Driver centric',
        description: 'Verbal safety alerts in real time can support changes to driver behaviour before incidents occur.',
        icon: '☁️'
      },
      {
        title: 'Enhanced coaching',
        description: 'Automated Workflows, AI generated insights and recommendations of specific grouped behaviors for coaching sessions.',
        icon: '🔧'
      }
    ]
  },
  
  solutions: {
    title: 'Professional Camera Solutions',
    subtitle: 'Advanced Geotab camera systems for enhanced safety and security',
    description: 'Our comprehensive camera solutions provide 360-degree visibility, AI-powered analytics, and seamless integration with your existing fleet management systems.',
    sections: [
      {
        title: 'Driver Tracking',
        description: 'Improve driver behavior with our robust suite of driver tracking and coaching tools. Find the productivity solutions that are right for your business. From scorecards and trend reports to collision avoidance systems, you can customize our solutions to fit your business and fleet.'
      },
      {
        title: 'Routing and dispatching',
        description: "Respond quickly to changing conditions by dispatching drivers in real time with MyGeotab. Geotab's routing solutions improve fleet productivity and help lower costs by leading your fleet down the right path."
      },
      {
        title: 'Fleet management reports',
        description: 'Understand your fleet data with custom reporting tools in MyGeotab. Improve fleet productivity, efficiency, safety and more with valuable insights derived from your data. Analyze your fleet on one robust fleet management platform today.'
      }
    ]
  },
  
  
  testimonials: [
    {
      content: "We have been running a great continuous improvement program for road safety using the MyGeotab fleet management platform, which supports our drivers' safe behaviours on the road. Geotab's fleet telematics solution is a wise investment for our employees' health and safety, which is a core cultural value in our organisation.",
      author: "Deniz Tuna",
      role: "Safety Champion (Commercial Sector)",
      company: "",
      avatar: "https://randomuser.me/api/portraits/women/32.jpg"
    },
    {
      content: "We've built a great relationship with Karl. He drives us to get great results. We present him with a problem and he goes away and figures it out.",
      author: "Michael Kidwell",
      role: "Vice President of Branch Operations",
      company: "",
      avatar: "https://randomuser.me/api/portraits/men/38.jpg"
    }
  ],

  blog: {
    title: 'Geotab Camera News & Insights',
    subtitle: 'Professional tips and industry updates.',
    description: 'Latest news, insights, and best practices for Geotab camera systems and fleet security. Professional tips and industry updates.',
  },
  
  // SEO and Meta
  seo: {
    // Basic Meta Tags
    title: 'Geotab Camera - Professional Fleet Camera Solutions',
    description: 'Ensure fleet safety with advanced Geotab cameras: HD recording, night vision, GPS tracking, AI analytics, and cloud storage.',
    keywords: [
      'Geotab camera', 'fleet cameras', 'dash cameras', 'fleet safety', 'camera systems', 'fleet management',
      'Geotab camera systems', 'fleet security cameras', 'camera solutions',
      'professional cameras', 'fleet camera technology', 'camera analytics','Geotab', 'Geotab solutions', 'Geotab Camera Solutions', 'Geotab Camera Products',
    ],
    
    // Open Graph & Social Media
    ogTitle: 'Geotab Camera - Professional Fleet Camera Solutions',
    ogDescription: 'Advanced camera systems for fleet safety and security. HD recording, night vision, GPS tracking, and cloud storage.',
    ogType: 'website',
    ogUrl: 'https://www.geotabcamera.com',
    
    // Twitter Cards
    twitterCard: 'summary_large_image',
    twitterTitle: 'Geotab Camera - Professional Fleet Camera Solutions',
    twitterDescription: 'Advanced camera systems for fleet safety and security. HD recording, night vision, GPS tracking, and cloud storage.',
    
    // Robots
    robots: 'index, follow',
    author: 'Geotab Camera',
    publisher: 'Geotab Camera',
    
    // Page-Specific SEO
    pages: {
      home: {
        title: 'Geotab Camera - Professional Fleet Camera Solutions',
        description: 'Advanced Geotab camera systems for fleet safety and security. HD recording, night vision, GPS tracking, and cloud storage.',
        keywords: ['Geotab camera', 'fleet cameras', 'fleet safety', 'camera systems', 'fleet security']
      },
      solutions: {
        title: 'Geotab Camera Solutions - Professional Fleet Camera Solutions',
        description: 'Comprehensive Geotab camera solutions for fleet security. Professional installation, AI analytics, and 24/7 monitoring services.',
        keywords: ['Geotab camera solutions', 'fleet security systems', 'camera installation', 'fleet monitoring']
      },
      products: {
        title: 'Geotab Camera Products - Professional Fleet Camera Equipment',
        description: 'Professional Geotab camera products and equipment for fleet management. HD cameras, night vision systems, and cloud storage solutions.',
        keywords: ['Geotab camera products', 'fleet camera equipment', 'HD cameras', 'night vision systems']
      },
      blog: {
        title: 'Geotab Camera News & Insights - Fleet Security Blog',
        description: 'Latest news, insights, and best practices for Geotab camera systems and fleet security. Professional tips and industry updates.',
        keywords: ['Geotab camera news', 'fleet security insights', 'camera best practices', 'fleet safety tips']
      }
    },
    
    // Performance & Technical SEO
    technical: {
      pageLoadTime: '< 1 second',
      mobileOptimized: true,
      sslEnabled: true,
      schemaMarkup: true,
      xmlSitemap: true,
      robotsTxt: true,
      compressionEnabled: true,
      imageOptimization: true,
      cdnEnabled: true
    },

    // Local Business Info for Structured Data
    localBusiness: {
      streetAddress: '',
      addressLocality: 'Atlanta',
      addressRegion: 'GA',
      postalCode: '30308',
      addressCountry: 'US'
    }
  }
};
